import { Typography } from '@mui/material'
import React, { Fragment, memo, useCallback } from 'react'
import tw from 'twin.macro'
import MVRIcon from 'src/assets/icons/bgc.svg'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { useYardstik } from 'src/hooks/useYardstik'
import { MVRCollectDataStep } from 'src/interfaces/collectData'
import { Button } from '../shared/Button'
import { SecureWrapper } from '../layout/SecureWrapper'
import { StepLabels } from '../client/step-labels/StepLabels'

interface Props {
  onBack?: () => void
}

const MVRYardstikComponent = ({ onBack }: Props) => {
  const currentStep = useSelector(getCurrentCollectDataStep) as MVRCollectDataStep

  const { isYardstikLoading, startYardstik, YardstikView } = useYardstik()

  const showYardstik = useCallback(() => {
    startYardstik(currentStep.id)
  }, [currentStep.id])

  return (
    <Fragment>
      <SecureWrapper
        onBack={onBack}
        footer={
          <Button
            className={tw`w-full`}
            loading={isYardstikLoading}
            onClick={showYardstik}
            data-testid="contractors-onboarding-mvr-yardstik-proceed-btn"
          >
            Proceed with Yardstik
          </Button>
        }
      >
        <div
          css={tw`w-11 h-11 flex justify-center items-center [border-radius: 22px] bg-shades-100 mt-2 mb-4`}
        >
          <img src={MVRIcon} />
        </div>
        <StepLabels />
        <Typography css={tw`mb-2 mt-2`} variant="h2">
          Motor Vehicle Record
        </Typography>
        <Typography css={tw`mb-4 text-shades-400`}>
          To conduct your Motor Vehicle Record report we'll use our industry leading partner,
          Yardstik. Tap "Proceed with Yardstik" button below to begin.
        </Typography>
      </SecureWrapper>
      <YardstikView />
    </Fragment>
  )
}

export const MVRYardstik = memo(MVRYardstikComponent)
